"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamMemberUser = exports.isTeamMemberUser = exports.UpdateUser = exports.isUpdateUser = exports.CreateUser = exports.isCreateUser = exports.User = exports.isUser = exports.isUserRole = exports.UserRole = void 0;
const uuid_1 = require("../types/uuid");
const validation_1 = require("../validator/validation");
const datelike_1 = require("../types/datelike");
const validation_2 = require("../validator/validation");
const ValidatorClass_1 = require("../validator/ValidatorClass");
var UserRole;
(function (UserRole) {
    UserRole["User"] = "USER";
    UserRole["System"] = "SYSTEM";
    UserRole["Admin"] = "ADMIN";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
exports.isUserRole = (0, validation_1.isLiteral)(UserRole.User, UserRole.System, UserRole.Admin);
exports.isUser = (0, validation_1.isObjectOf)({
    id: uuid_1.isUUID,
    email: validation_1.isString,
    fullName: validation_1.isString,
    createdAt: (0, validation_1.optional)(datelike_1.isDateLike),
    tosVersionAgreed: (0, validation_1.optional)(datelike_1.isDateLike),
    stripeCustomerId: (0, validation_1.optional)(validation_1.isString),
});
class User extends (0, ValidatorClass_1.ValidatorClass)(exports.isUser) {
}
exports.User = User;
exports.isCreateUser = (0, validation_1.isObjectOf)({
    email: validation_1.isEmail,
    fullName: validation_1.isString.which((0, validation_1.satisfiesCondition)(s => s.length > 0)),
    identityId: validation_2.isNull.or(validation_1.isUndefined).or(validation_1.isString),
});
class CreateUser extends (0, ValidatorClass_1.ValidatorClass)(exports.isCreateUser) {
}
exports.CreateUser = CreateUser;
exports.isUpdateUser = (0, validation_1.isObjectOf)({
    fullName: validation_1.isString.which((0, validation_1.satisfiesCondition)(s => s.length > 0)),
});
class UpdateUser extends (0, ValidatorClass_1.ValidatorClass)(exports.isUpdateUser) {
}
exports.UpdateUser = UpdateUser;
exports.isTeamMemberUser = (0, validation_1.isObjectOf)({
    id: uuid_1.isUUID,
    email: validation_1.isEmail,
    fullName: validation_1.isString.which((0, validation_1.satisfiesCondition)(s => s.length > 0)),
});
class TeamMemberUser extends (0, ValidatorClass_1.ValidatorClass)(exports.isTeamMemberUser) {
}
exports.TeamMemberUser = TeamMemberUser;
//# sourceMappingURL=users.js.map